module.exports = __webpack_public_path__ + "static/media/image4.66aca9e1.png";